import { FunctionComponent } from 'react'
import styled from 'styled-components'

import * as T from './types'

const StyledAnchor = styled.div<T.ISelectedProps>`
  margin: 4px;
  padding: 8px 12px;
  ${props => props.selected && `color: ${props.theme.colors.purple};`}
  background: ${props => props.theme.colors.white};
  box-shadow: 1px 2px 3px ${props => props.theme.colors.transparentBlackAlpha10};
  border: 2px solid ${props => props.theme.colors[props.selected ? 'purple' : 'transparent']};
  border-radius: 100px;

  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  text-align: center;

  cursor: pointer;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin: 10px;
    padding: 10px 23px;
    font-size: 16px;
    line-height: 16px;
  }
`

const Anchor: FunctionComponent<T.IAnchorProps> = ({ anchor, selectedAnchor, selectAnchor }) => (
  <div
    role="presentation"
    key={anchor.anchor}
    onClick={() => selectAnchor(anchor.anchor)}
  >
    <StyledAnchor selected={selectedAnchor === anchor.anchor}>{anchor.title}</StyledAnchor>
  </div>
)

export default Anchor
